import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import AccountManagement from "./pages/AccountManagement";
import AccountDetail from "./pages/AccountDetail";
import AdminPanel from "./pages/adminPanel/AdminPanel";
import ProtectedRoute from "./components/ProtectedRoute";

const MIN_DESKTOP_WIDTH_PX = 768;

function App() {
  const [isMobileViewport, setIsMobileViewport] = useState(
    window.innerWidth < MIN_DESKTOP_WIDTH_PX,
  );

  useEffect(() => {
    const onResize = () => {
      setIsMobileViewport(window.innerWidth < MIN_DESKTOP_WIDTH_PX);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  if (isMobileViewport) {
    return (
      <main
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background: "#f8f8f8",
        }}
      >
        <section
          style={{
            maxWidth: "520px",
            border: "1px solid #d0d0d0",
            background: "#fff",
            padding: "20px",
          }}
        >
          <h1 style={{ margin: "0 0 10px", fontSize: "20px", lineHeight: 1.3 }}>
            Desktop Required
          </h1>
          <p style={{ margin: 0, fontSize: "14px", lineHeight: 1.5 }}>
            This demo is optimized for desktop layouts. Please switch to a
            desktop or widen your browser window to continue.
          </p>
        </section>
      </main>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Landing />} />

        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <AccountManagement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/account/:accountId"
          element={
            <ProtectedRoute>
              <AccountDetail />
            </ProtectedRoute>
          }
        />

        {/* Admin panel is not protected */}
        <Route path="/admin" element={<AdminPanel />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
